import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useParams } from "react-router-dom";
import { Col, Row, Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap"
import './App.scss'
import Feed from "./views/Feed/Feed";
import SignUp from "./views/Onboarding/SignUp";
import RAFLanding from "./views/Onboarding/RAFLanding";
import RAFSurge from "./views/ReferAFriend/RAFSurge";
import WebRetroLanding from "./views/Onboarding/WebRetroLanding";
import RAFDownload from "./views/Onboarding/RAFDownload";
import WebRetroDownload from "./views/Onboarding/WebRetroDownload";
import WebRegistrationDownload from "./views/Onboarding/WebRegistration";
import DataTypeInstructions from "./views/Retro/DataTypeInstructions";
import ScreenRecordingInstructionsIOS from "./views/Retro/ScreenRecordingInstructionsIOS";
import ScreenRecordingInstructionsAndroid from "./views/Retro/ScreenRecordingInstructionsAndroid";
import WalmartInstructions from './views/Retro/WalmartInstructions';
import JobClient from "./views/Jobs/JobClient";
import Uploader from "./views/Jobs/Uploader";
import MultipartTest from "./views/Jobs/MultipartTest";
const queryString = require('query-string');

function InstructionsWithParams() {
  let { dataType, platform } = useParams();

  // Note: Not sure that this should be here vs consolidated somewhere else, but
  // it's here for when the instructions are used without the JobClient (and now
  // lang is required for some instructions).

  const parsed = queryString.parse(window.location.search);
  const lang = (parsed.lang ? parsed.lang.toLowerCase() : null) || 'en';

  return <DataTypeInstructions dataType={dataType} platform={platform} lang={lang} />;
}

function Home() {

  return (
    <div className="container-lg">
      <Row>
        <Col>
          <h1>Home</h1>
          <nav>
            <p className="before-list">App bits:</p>
            <ul>
              <li>
                <Link to="/sign-up">Sign Up</Link>
              </li>
              <li>
                <Link to="/landing">RAF Landing</Link>
              </li>
              <li>
                <Link to="/download">RAF Download</Link>
              </li>
              <li>
                <Link to="/raf40?invite_code=ABCD123456">RAF 40 Surge</Link>
              </li>
              <li>
                <Link to="/raf20?invite_code=ABCD123456">RAF 20 Surge</Link>
              </li>
              <li>
                <Link to="/web-retro-landing">Web Retro Landing</Link>
              </li>
              <li>
                <Link to="/web-retro-download">Web Retro Download</Link>
              </li>
                <li>
                    <Link to="/web-registration-download">Web Registration Download</Link>
                </li>
              <li>
                <Link to="/feed">Mock Feed</Link>
              </li>
              <li>
                <Link to="/retro/help/screen-recording/ios">Screen Recording Instructions (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/help/screen-recording/android">Screen Recording Instructions (Android)</Link>
              </li>
            </ul>
            <p className="before-list">Retro instructions:</p>
            <ul>
                <li>
                    <Link to="/retro/instructions/instagram_user_following/ios">Instagram Following (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/instagram_user_following/android">Instagram Following (Android)</Link>
                </li>
              <li>
                  <Link to="/retro/instructions/microsoft_device_id/ios">Microsoft DeviceId (iOS)</Link>
              </li>
              <li>
                  <Link to="/retro/instructions/microsoft_device_id/android">Microsoft DeviceId (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/youtube_watch_history/ios">YouTube Instructions (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/youtube_watch_history/android">YouTube Instructions (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/installed_apps/ios?video=0">Installed Apps (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/installed_apps/android?video=0">Installed Apps (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/netflix_watch_history/ios?video=0">Netflix Watch History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/netflix_watch_history/android?video=0">Netflix Watch History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/screen_time_stats/ios?video=1">Screen Time Stats (iOS)</Link>
              </li>
              <li>
                  <Link to="/retro/instructions/screen_time_stats_last_week/ios?video=1">Screen Time Stats - Last Week (iOS)</Link>
              </li>
              <li>
                  <Link to="/retro/instructions/battery_stats/ios?video=0">Battery Stats (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/amazon_order_history/ios?video=0">Amazon Order History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/amazon_order_history/android?video=0">Amazon Order History (Android)</Link>
              </li>
              <li>
                  <Link to="/retro/instructions/amazon_search_history/ios?video=0">Amazon Search History (iOS)</Link>
              </li>
              <li>
                  <Link to="/retro/instructions/amazon_search_history/android?video=0">Amazon Search History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/wholefoods_order_history/ios?video=0">Wholefoods Order History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/wholefoods_order_history/android?video=0">Wholefoods Order History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/instacart_order_history/ios?video=0">Instacart Order History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/instacart_order_history/android?video=0">Instacart Order History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/uber_ride_history/ios?video=1">Uber Ride History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/uber_ride_history/android?video=1">Uber Ride History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/lyft_ride_history/ios?video=1">Lyft Ride History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/lyft_ride_history/android?video=1">Lyft Ride History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/doordash_order_history/ios?video=0">Doordash Order History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/doordash_order_history/android?video=0">Doordash Order History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/safari_web_browsing_history/ios?video=0">Safari Web Browsing History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/chrome_web_browsing_history/ios?video=0">Chrome Web Browsing History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/chrome_web_browsing_history/android?video=0">Chrome Web Browsing History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/app_store_purchase_history/ios?video=0">App Store Purchase History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/app_store_purchase_history/android?video=0">App Store Purchase History (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/instagram_shopping_history/ios?video=0">Instagram Shopping History (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/instagram_ad_activity/ios?video=0">Instagram Ad Activity (iOS)</Link>
              </li>
                <li>
                    <Link to="/retro/instructions/instagram_ad_activity/android?video=0">Instagram Ad Activity (Android)</Link>
                </li>
              <li>
                <Link to="/retro/instructions/instagram_link_activity/android?video=0">Instagram Link Activity (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/google_activity/ios?video=0">Google My Activity (iOS)</Link>
              </li>
              <li>
                  <Link to="/retro/instructions/ios_storage/ios?video=0">iOS Storage (iOS)</Link>
              </li>
                <li>
                    <Link to="/retro/instructions/home_screen_content/ios?video=0">Home Screen (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/target_order_detail/ios?video=0">Target (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/target_order_detail/android?video=0">Target (Android)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/walmart_order_history/ios?video=0">Walmart (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/walmart_order_history/android?video=0">Walmart (Android)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/tiktok_data_export/ios?video=0">TikTok Data Export (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/twitch_channels/ios?video=0">Twitch (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/twitch_channels/android?video=0">Twitch (Android)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/steam_purchases/ios?video=0">Steam (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/steam_purchases/android?video=0">Steam (Android)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/chatgpt_data_upload/ios?video=0">ChatGPT (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/chatgpt_data_upload/android?video=0">ChatGPT (Android)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/spotify_data_upload/ios?video=0">Spotify (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/spotify_data_upload/android?video=0">Spotify (Android)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/apple_data_upload/ios?video=0">Apple (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/hulu_data_upload/ios?video=0">Hulu (iOS)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/hulu_data_upload/android?video=0">Hulu (Android)</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/screen_time_stats_21_day/ios?video=0">ScreenTime - 21 days</Link>
                </li>
                <li>
                    <Link to="/retro/instructions/ios_apple_intelligence_export/ios?video=0">Apple Intelligence Report</Link>
                </li>
            </ul>
            <p className="before-list">Custom instructions:</p>
            <ul>
              <li>
                <Link to="/retro/instructions/custom_video/ios?custom=1&video=0&app=YouTube&thing=watch%20history&logo=https%3A%2F%2Fmeasure-static.s3.us-east-1.amazonaws.com%2Fc2%2Fretro%2Fyoutube-watch-history%2Flogo.png">Custom Video Instructions (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/custom_video/android?custom=1&video=0&app=YouTube&thing=watch%20history&logo=https%3A%2F%2Fmeasure-static.s3.us-east-1.amazonaws.com%2Fc2%2Fretro%2Fyoutube-watch-history%2Flogo.png">Custom Video Instructions (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/custom_file/ios?custom=1&video=0&app=Google&thing=Google%20data%20export&logo=https%3A%2F%2Fmeasure-static.s3.us-east-1.amazonaws.com%2Fc2%2Fretro%2Fgoogle-data-export%2Flogo.png">Custom File Instructions (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/custom_file/android?custom=1&video=0&app=Google&thing=Google%20data%20export&logo=https%3A%2F%2Fmeasure-static.s3.us-east-1.amazonaws.com%2Fc2%2Fretro%2Fgoogle-data-export%2Flogo.png">Custom File Instructions (Android)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/custom_image/ios?custom=1&video=0&app=Camera&thing=open%20refrigerator&logo=https%3A%2F%2Fmeasure-static.s3.us-east-1.amazonaws.com%2Fc2%2Fretro%2Fcustom-image%2Flogo.jpg">Custom Image Instructions (iOS)</Link>
              </li>
              <li>
                <Link to="/retro/instructions/custom_image/android?custom=1&video=0&app=Camera&thing=open%20refrigerator&logo=https%3A%2F%2Fmeasure-static.s3.us-east-1.amazonaws.com%2Fc2%2Fretro%2Fcustom-image%2Flogo.jpg">Custom Image Instructions (Android)</Link>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/feed">
          <Feed />
        </Route>
        <Route path="/sign-up">
          <SignUp />
        </Route>
        <Route path="/landing">
          <RAFLanding />
        </Route>
        <Route path="/download">
          <RAFDownload />
        </Route>
        <Route path="/raf40">
          <RAFSurge bonus="40%" />
        </Route>
        <Route path="/raf20">
          <RAFSurge bonus="20%" />
        </Route>
        <Route path="/web-retro-landing">
          <WebRetroLanding />
        </Route>
        <Route path="/web-retro-download">
          <WebRetroDownload />
        </Route>
        <Route path="/web-registration-download">
          <WebRegistrationDownload />
        </Route>
        <Route path="/job">
          <JobClient embedded={false} />
        </Route>
        <Route path="/embedded-job">
          <JobClient embedded={true} />
        </Route>
        <Route path="/uploader">
          <Uploader />
        </Route>
        <Route path="/retro/instructions/:dataType/:platform">
          <InstructionsWithParams />
        </Route>
        <Route path="/retro/help/walmart/ios">
          <WalmartInstructions/>
        </Route>
        <Route path="/retro/help/screen-recording/ios">
          <ScreenRecordingInstructionsIOS />
        </Route>
        <Route path="/retro/help/screen-recording/android">
          <ScreenRecordingInstructionsAndroid />
        </Route>
        <Route path="/multi">
          <MultipartTest />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
